import type { Message, MessageRoleEnum } from '../../gen/openapi';
import type { ClientChatResponse } from '../../types/ClientMessage';

/** Factories shared by the chat provider and the background-task hand-off. */

export const newMessage = (
  content: string,
  role: MessageRoleEnum = 'user',
  isError?: boolean,
  hidden?: boolean,
): ClientChatResponse => ({
  timestamp: new Date(),
  role,
  content,
  isError,
  hidden,
});

export const toApiMessage = (clientMessage: ClientChatResponse): Message => ({
  timestamp: clientMessage.timestamp,
  role: (clientMessage.role || 'assistant') as 'user' | 'assistant',
  content: clientMessage.content,
});
